import React,{useState, useEffect} from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import PacmanLoader from "react-spinners/PacmanLoader";
import {useNavigate, useParams} from "react-router-dom";
//import { updateUser } from './backend/controller/UserController';


const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const EditBarang = () => {

    const {id} = useParams();
    const [kodeBarang, setKodeBarang] = useState("");
    const [namaBarang, setNamaBarang] = useState("");
    const [kodeKategori, setKodeKategori] = useState("-----");
    const [qtyMax, setQtyMax] = useState("");
    const [qtyMin, setQtyMin] = useState("");
    const [stok, setStok] = useState("");
    const [ket, setKet] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();



useEffect(() => {
    getBarangByid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
},[]);

const updateBarang = async (e) =>{
    e.preventDefault();
    setLoading(true)
    if(kodeKategori==="-----"){
        alert("Silahkan Pilih Kategori Barang...");
    }else{
        let formData = new FormData();
        formData.append('kodeBarang',kodeBarang);
        formData.append('namaBarang',namaBarang);
        formData.append('kodeKategori',kodeKategori);
        formData.append('qtyMin',qtyMin);
        formData.append('qtyMax',qtyMax);
        formData.append('stok',stok);
        formData.append('ket',ket);

        try {
            await axios.patch(`${process.env.REACT_APP_MASTER_URL}/updatebarang/${id}`,formData,{
                headers:{ 
                    'Content-Type':'multipart/form-data'
                }
            });
            toast.info("Edit Barang Berhasil");
            navigate("/")
        } catch (error) {
            setLoading(false)
            toast.error("Gagal, Kesalahan Server");
            console.log(error);
        }
    }
}

const getBarangByid = async () =>{
    const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/barang/${id}`)
    setKodeBarang(response.data.kodeBarang);
    setNamaBarang(response.data.namaBarang);
    setKodeKategori(response.data.kodeKategori);
    setQtyMax(response.data.qtyMax);
    setQtyMin(response.data.qtyMin);
    setStok(response.data.stok);
    setKet(response.data.ket);
    
};

const styleTittle = {

    fontSize: 20,

    color: "#4a54f1",

    textAlign: "center",

    paddingBottom: "60px",
}


  return (
     <section className="hero has-background-grey-light is-fullheight is-fullwidth">
        {loading ?
            <div style={stylespinner}>
                <PacmanLoader
                    color={'#301E67'}
                    loading={loading}
                    size={30}
                    textAlign='centered'
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                </div> 
        :
    <div className="section is-fullheight" style={{backgroundColor: '#1b48f1', filterImage:'blur(50px)'}} >
    <div className='field' ></div>
    <div className="container ">
        <div className="column is-6 is-offset-3">
        <div className="box" >
                <img src={`${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`}  alt="Not Found" width={300} height={300}></img>
                <label className='label' style={styleTittle}><center>Form Edit Barang</center></label>
            <form onSubmit={updateBarang}>
            <div className='field'>
                        <label className='label'>Kode Barang</label>
                        <div class='control' has-icons-left has-icons-right>
                            <input required type='text' className="input" value={kodeBarang} onChange={(e)=> setKodeBarang(e.target.value)} placeholder='Nama Barang'></input>                    </div>
                    </div>
                <div className='field'>
                    <label className='label'>Nama Barang</label>
                    <div class='control' has-icons-left has-icons-right>
                        <input required type='text' className="input" value={namaBarang} onChange={(e)=> setNamaBarang(e.target.value)} placeholder='Nama Barang'></input>                    </div>
                </div>
                <div className='field'>
                    <label className='label'>Kategori</label>
                    <div className='control'>
                        <div className='select is-fullwidth'>
                            <select value={kodeKategori} onChange={(e)=> setKodeKategori(e.target.value)}>
                            <option value="-----">--Silahkan Pilih--</option>
                                <option value="1">Suvenir</option>
                                <option value="2">ATK</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className='field'>
                    <label className='label'>Stok Maksimal</label>
                    <div className='control'>
                        <input required type='number' className="input" value={qtyMax} onChange={(e)=> setQtyMax(e.target.value)} placeholder='Masukan Angka'></input>
                    </div>
                </div>
                <div className='field'>
                    <label className='label'>Stok Minimal</label>
                    <div className='control'>
                        <input required type='number' className="input" value={qtyMin} onChange={(e)=> setQtyMin(e.target.value)} placeholder='Masukan Angka'></input>
                    </div>
                </div>
                <div className='field'>
                    <label className='label'>Stok </label>
                    <div className='control'>
                        <input required type='number' className="input" value={stok} onChange={(e)=> setStok(e.target.value)} placeholder='Stok Saat Ini'></input>
                    </div>
                </div>
                <div className='field'>
                    <label className='label'>Keterangan</label>
                    <div className='control'>
                        <input required type='text' className="input" value={ket} onChange={(e)=> setKet(e.target.value)} placeholder='Keterangan'></input>
                    </div>
                </div>
                <div className='field mt-5'>
                        <button type='submit' className='button is-link'>Update</button>
                        <button type="button" onClick={() => navigate(-1)} className='button is-primary ml-5'>Back</button>
                    </div>
            </form>
        </div>
    </div>
    </div>
    </div>
    }
   </section>
  )
}

export default EditBarang